import { AutogenModelDivisionLookup, AutogenRowDivisionLookup } from "./autogen/AutogenModelDivisionLookup";

export class ModelDivisionLookup extends AutogenModelDivisionLookup<RowDivisionLookup> {
	constructor() {
		super(RowDivisionLookup);
	}
}

export class RowDivisionLookup extends AutogenRowDivisionLookup {
}